<template lang="pug">
	.multi-level-dropdown-menu.dropdown-menu(ref="root" v-if="items" :style="{width: `${width}px`, 'max-height': `90vh`}")
		.header(v-if="header")
			.header-text
				.header-title {{header.title}}
				.header-description.text-muted {{header.description}}
			//- Кнопка в хидере (header.button: {title, icon, data, disabled}) - вне прокручиваемого списка, всегда видна при открытии меню
			button.header-button.btn.btn-sm.btn-ghost(v-if="header.button" type="button" :disabled="header.button.disabled" @click.stop="chooseItem(header.button)")
				i.fa(v-if="header.button.icon" :class="header.button.icon")
				span(v-if="header.button.title") {{header.button.title}}
		.mldm-items(v-bar :style="{height: height ? `${height}px` : 'auto'}")
			.mldm-items-inner
				.mldm-item(v-for="item in items" :class="{opened: openedItems[0] === item}" @click="selectItem(items, item, [], $event)")
					.mldm-item-title(:class="{'action-item': !item.childs, empty: item.childs && item.childs.length === 0, disabled: item.disabled, wrap: item.wordWrap}" :style="getItemTitleStyle(item)")
						.fa.fa-angle-double-left(v-if="!!item.childs")
						.fa(v-if="item.icon" :class="item.icon")
						span {{item.title}}
					.mldm-item-description(v-if="!item.requestInlineTextActive" :class="{disabled: item.disabled}") {{item.description}}
					.mldm-item-input(v-if="item.requestInlineTextActive")
						input.style-input.form-control.form-control-sm(type="text" placeholder="Write a new message here" v-model="inlineText" @keypress="putInlineText($event, item, [openedItems[0]])")
						button.btn.btn-sm.btn-ghost-dark(@click.stop="addInlineText(item, [openedItems[0]])")
							i.fa.fa-plus
		.mldm-level-items(v-bar v-if="openedItems[0]" :style="{width: `${openedItems[0].width}px`, right: `${openedItems[0].right}px`, top: `${openedItems[0].top}px`}")
			.mldm-level-items-inner
				.mldm-item(v-for="item in openedItems[0].childs" :class="{opened: openedItems[1] === item}" @click.stop="selectItem(openedItems[0].childs, item, [openedItems[0]], $event)")
					.mldm-item-title(:class="{'action-item': !item.childs, empty: item.childs && item.childs.length === 0, disabled: item.disabled, wrap: item.wordWrap}" :style="getItemTitleStyle(item)")
						.fa.fa-angle-double-left(v-if="!!item.childs")
						.fa(v-if="item.icon" :class="item.icon")
						span {{item.title}}
					.mldm-item-description(v-if="!item.requestInlineTextActive" :class="{disabled: item.disabled}") {{item.description}}
					.mldm-item-input(v-if="item.requestInlineTextActive")
						input.style-input.form-control.form-control-sm(type="text" placeholder="Write a new message here" v-model="inlineText" @keypress="putInlineText($event, item, [openedItems[0]])")
						button.btn.btn-sm.btn-ghost-dark(@click.stop="addInlineText(item, [openedItems[0]])")
							i.fa.fa-plus
		.mldm-level-items(v-bar v-if="openedItems[1]" :style="{width: `${openedItems[1].width}px`, right: `${openedItems[1].right}px`, top: `${openedItems[1].top}px`}")
			.mldm-level-items-inner
				.mldm-item(v-for="item in openedItems[1].childs" :class="{opened: openedItems[2] === item}" @click.stop="selectItem(openedItems[1].childs, item, [openedItems[1], openedItems[0]], $event)")
					.mldm-item-title(:class="{'action-item': !item.childs, empty: item.childs && item.childs.length === 0, disabled: item.disabled, wrap: item.wordWrap}" :style="getItemTitleStyle(item)")
						.fa.fa-angle-double-left(v-if="!!item.childs")
						.fa(v-if="item.icon" :class="item.icon")
						span {{item.title}}
					.mldm-item-description(:class="{disabled: item.disabled}") {{item.description}}
		.mldm-level-items(v-bar v-if="openedItems[2]" :style="{width: `${openedItems[2].width}px`, right: `${openedItems[2].right}px`, top: `${openedItems[2].top}px`}")
			.mldm-level-items-inner
				.mldm-item(v-for="item in openedItems[2].childs" :class="{opened: openedItems[3] === item}" @click.stop="selectItem(openedItems[2].childs, item, [openedItems[2], openedItems[1], openedItems[0]], $event)")
					.mldm-item-title(:class="{'action-item': !item.childs, empty: item.childs && item.childs.length === 0, disabled: item.disabled, wrap: item.wordWrap}" :style="getItemTitleStyle(item)")
						.fa.fa-angle-double-left(v-if="!!item.childs")
						.fa(v-if="item.icon" :class="item.icon")
						span {{item.title}}
					.mldm-item-description(:class="{disabled: item.disabled}") {{item.description}}
		.mldm-level-items(v-bar v-if="openedItems[3]" :style="{width: `${openedItems[3].width}px`, right: `${openedItems[3].right}px`, top: `${openedItems[3].top}px`}")
			.mldm-level-items-inner
				.mldm-item(v-for="item in openedItems[3].childs" :class="{opened: openedItems[4] === item}" @click.stop="selectItem(openedItems[3].childs, item, [openedItems[3], openedItems[2], openedItems[1], openedItems[0]], $event)")
					.mldm-item-title(:class="{'action-item': !item.childs, empty: item.childs && item.childs.length === 0, disabled: item.disabled, wrap: item.wordWrap}" :style="getItemTitleStyle(item)")
						.fa.fa-angle-double-left(v-if="!!item.childs")
						.fa(v-if="item.icon" :class="item.icon")
						span {{item.title}}
					.mldm-item-description(:class="{disabled: item.disabled}") {{item.description}}
		.mldm-level-items(v-bar v-if="openedItems[4]" :style="{width: `${openedItems[4].width}px`, right: `${openedItems[4].right}px`, top: `${openedItems[4].top}px`}")
			.mldm-level-items-inner
				.mldm-item(v-for="item in openedItems[4].childs" :class="{opened: false}" @click.stop="selectItem(openedItems[4].childs, item, [openedItems[4], openedItems[3], openedItems[2], openedItems[1], openedItems[0]], $event)")
					.mldm-item-title(:class="{'action-item': !item.childs, empty: item.childs && item.childs.length === 0, disabled: item.disabled, wrap: item.wordWrap}" :style="getItemTitleStyle(item)")
						.fa.fa-angle-double-left(v-if="!!item.childs")
						.fa(v-if="item.icon" :class="item.icon")
						span {{item.title}}
					.mldm-item-description(:class="{disabled: item.disabled}") {{item.description}}
</template>

<script>
	import Screen from './../../mixins/screen'

	// Зазор между меню и открытым слева подменю по внешним краям (px)
	const SUBMENU_GAP = 1;

	export default {
		name: 'MultiLevelDropdownMenu',
		mixins: [Screen],
		props: ["width", "height", "header"],
		data() {

			this.openedItems = [];

			return {
				showed: true,
				items: [],
				inlineText: ''
			};
		},
		methods: {
			collectData() {

			},
			getItemTitleStyle(item) {

				let color = item.titleColor || item.color;

				if (!color) return null;

				if (color.startsWith('--')) color = `var(${color})`;

				return {color};

			},
			setItems(items) {

				this.items = items;

			},
			selectItem(sameLevelItemsList, item, parentItems = [], domEvent) {

				if (item.disabled) return;

				// Если у пункта меню есть внутренние пункты
				if (item.childs) {

					if (item.childs.length === 0) return;

					let isOpened = this.openedItems[parentItems.length] === item;

					// Если не открыто подменю - открываем
					if (!isOpened) {

						this.openItem(item, parentItems, domEvent);

						//if (item.childs.length === 1) this.openItem(item.childs[0], parentItems, domEvent);

					}

					// иначе - закрываем подменю
					else this.closeItem(item, parentItems);

				// Если у пункта нет подменю
				} else {

					// Если нужно загрузить новый ассет
					if (item.action === 'upload-asset') this.uploadAsset(item, parentItems);

					// Если нужно запросить у пользователя ввод текста
					else if (item.inlineRequestText) this.requestInlineText(item, parentItems);

					// Запускаем выбор окончательного элемента меню
					else this.chooseItem(item, parentItems);

				}

			},
			openItem(item, parentItems, domEvent) {

				item.clientRect = domEvent.currentTarget.getBoundingClientRect();

				let root = this.$refs["root"],
					rootRect = root.getBoundingClientRect();

				// Подменю открывается слева от родителя. Свойство right отсчитывается от внутреннего (padding) края
				// корневого меню, поэтому зазор считается по внешним краям: ширина меню без рамки + зазор
				let right = rootRect.width - root.clientLeft + SUBMENU_GAP;

				// Каждый следующий уровень смещается ещё на ширину родительского подменю (берём её из DOM) плюс зазор
				let levelElements = this.$el.querySelectorAll(".mldm-level-items");

				_.each(parentItems, (parentItem, index) => {

					let parentElement = levelElements[index];

					right += (parentElement ? parentElement.getBoundingClientRect().width : (parentItem.width || 0)) + SUBMENU_GAP;

				});

				item.right = right;
				item.top = item.clientRect.top - rootRect.top - 1;

				this.openedItems[parentItems.length] = item;
				this.openedItems.length = parentItems.length + 1;

				this.$forceUpdate();

			},
			closeItem(item, parentItems) {

				this.openedItems.length = parentItems.length;

				this.$forceUpdate();

			},
			uploadAsset(item, parentItems = []) {

				// Spine состоит из трёх файлов (json + atlas + png) - выбираются сразу все три
				if (item.assetType === 'spine') {

					Asset.requestFiles('.json, .atlas, .png, image/png, application/json', files => {

						if (Asset.addSpineAsset({type: item.assetType}, files)) this.chooseUploadedAsset(item, parentItems);

					});

				// Спрайтовая анимация состоит из нескольких файлов (кадры, спрайт-лист или json атласа + текстура) - выбираются сразу все
				} else if (item.assetType === 'sprite-animation') {

					Asset.requestFiles('.png, .jpg, .jpeg, .json, image/png, image/jpeg, application/json', files => {

						// Вид анимации (последовательность кадров, спрайт-лист или атлас с json) определяет сервер
						if (Asset.addSpriteAnimationAsset({type: item.assetType}, files)) this.chooseUploadedAsset(item, parentItems);

					});

				} else {

					Asset.requestFile(item.assetType, file => {

						Asset.addAsset({type: item.assetType}, file);

						this.chooseUploadedAsset(item, parentItems);

					});

				}

			},
			// После создания ассета на сервере выбираем пункт меню с codename нового ассета
			chooseUploadedAsset(item, parentItems = []) {

				Broadcast.once("Selected Version Assets Changed", (...assetsData) => {

					if (!assetsData.length || !assetsData[0][1]) return;

					item.data.assetCodename = assetsData[0][1];

					this.chooseItem(item, parentItems);

				}, "Dropdown Element Type Image");

			},
			requestInlineText(item, parentItems = []) {

				console.log('requestInlineText', item);

				item.requestInlineTextActive = true;

				this.update();

			},
			addInlineText(item, parentItems = []) {

				item.data.inlineText = this.inlineText;

				this.inlineText = '';

				this.chooseItem(item, parentItems);

			},
			putInlineText(e, item, parentItems = []) {

				if (item.requestInlineTextActive && e.keyCode === 13) {

					item.requestInlineTextActive = false;

					this.addInlineText(item, parentItems);

				}

			},
			chooseItem(item, parentItems = []) {

				let data = {...item.data};

				parentItems.forEach(item => {

					if (item.data) _.extend(data, item.data);

				});

				if (item.requestInlineTextActive) item.requestInlineTextActive = false;

				this.$emit('change', {item, data});

				this.close();

			},
			close() {

				this.openedItems.length = 0;

			}
		}
	}
</script>

<style lang="sass">

	.multi-level-dropdown-menu.dropdown-menu
		top: 5px
		right: 0
		left: auto
		//border-color: #3f454b
		width: 200px
		margin: 0
		padding: 0
		overflow: visible
		min-width: auto

		.header
			display: flex
			flex-direction: row
			align-items: center
			gap: 8px
			background-color: #343b41
			padding: 5px 0px 5px 10px
			color: #e4e7ea
			border-radius: 0.25rem

			.header-text
				flex: 1 1 auto
				min-width: 0

			.header-button
				flex: 0 0 auto
				display: flex
				flex-direction: row
				align-items: center
				gap: 6px
				padding: 2px 8px
				font-size: 12px
				white-space: nowrap
				color: var(--gray)
				font-weight: bold

				i
					margin-top: 2px

			.header-button:hover
				color: var(--primary)

			.header-title
				white-space: nowrap
				font-size: 14px
				overflow: hidden !important
				width: 100% !important

			.header-description
				font-size: 11px


		.mldm-items
			border-radius: 0.25rem

			.mldm-items-inner

				.mldm-item
					width: calc(100% + 20px)


		.mldm-item
			display: flex
			flex-direction: column
			justify-content: flex-start
			position: relative
			padding: 0.25rem 0
			font-size: 0.765625rem
			border-bottom: 1px solid #3f454b
			background-color: rgba(255, 255, 255, 0.1)
			color: rgba(255,255,255,0.5)
			cursor: pointer
			width: 100%

			&:last-child
				border-bottom: none

			&:hover
				background-color: rgba(255, 255, 255, 0.03)

			&.opened
				background-color: rgba(255, 255, 255, 0.03)

		.mldm-item-title
			display: flex
			flex-direction: row
			color: rgba(255,255,255,1)
			overflow: hidden
			text-overflow: ellipsis
			margin-left: 0
			white-space: nowrap
			font-size: 13px
			align-items: baseline
			padding-right: 10px

			&.action-item
				padding: 0 10px
				color: var(--green)

				.fa
					margin-right: 10px

			&.empty
				color: rgba(255,255,255,0.4)



			&.disabled
				color: rgba(255,255,255,0.1)

			&.wrap
				white-space: normal

		.mldm-item-description
			margin-left: 0
			padding: 0 10px
			white-space: normal
			font-size: 11px
			color: rgba(255,255,255,0.4)

			&.disabled
				color: rgba(255,255,255,0.1)

		.mldm-item-input
			display: flex
			flex-direction: row
			white-space: nowrap
			padding: 5px 10px

			input
				outline: none
				box-shadow: none
				border-radius: 0.1rem
				color: rgba(255, 255, 255, 0.87)
				background-color: rgba(255, 255, 255, 0.05)
				border: 1px solid rgba(255, 255, 255, 0.09)

			input::placeholder
				color: rgba(255, 255, 255, 0.3)

			button
				width: 28px
				height: 28px
				border-radius: 3px
				outline: none
				box-shadow: none
				margin-left: 5px

				i

		.fa
			display: flex
			align-items: center
			justify-content: center

			&.fa-angle-double-left
				width: 24px

		.fa:nth-child(2)
			margin-right: 10px

		.mldm-level-items
			position: absolute !important
			right: 0
			top: 0
			border: 1px solid #23282c
			border-radius: 0.25rem
			background-color: #3a4149
			background-clip: padding-box
			box-shadow: 0 0 10px rgba(0, 0, 0, 0.5)
			margin-top: -1px

</style>
